import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getBlogById } from "../../Api/blog";
import { API_URL } from "../../Config/environment";
import Section from "../Section";
import Breadcrumb from "../Breadcrumb";
import Spacing from "../Spacing";
import Sidebar from "../Sidebar";
import BannerSectionStyle9 from "../Section/BannerSection/BannerSectionStyle9";
import { Icon } from "@iconify/react";
import { getArticleById } from "../../Api/article";
import Seo from "../../helpers/Seo";

export default function ArticleDetails() {
  const { articleId } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchArticle() {
      try {
        setLoading(true);
        const res = await getArticleById(articleId);
        console.log("Fetched Article data:", res);
        setArticle(res?.article || res?.data?.article || res);
      } catch (err) {
        console.error("Error fetching article details:", err);
      } finally {
        setLoading(false);
      }
    }

    if (articleId) fetchArticle();
  }, [articleId]);

  if (loading) return <p className="text-center mt-20">Loading article...</p>;
  if (!article) return <p className="text-center mt-20 text-red-500">Article not found.</p>;

  return (
    <Section topMd={150}
      topLg={70}
      topXl={50}>

      <Seo
        title={article?.metaTitle || article?.title}
        description={article?.metaDescription || article?.subTitle}
        image={
          article?.imageUrl?.length
            ? `${API_URL}/uploads/healthArticles/${article.imageUrl[0]}`
            : "/images/ogImage.png"
        }
        url={`https://gkcklinica.com/article/${article?.id}`}
        keywords={article?.keywords?.join(", ")}
      />
      {/* Header Section */}
      <Section topMd={170} bottomMd={54} bottomLg={54}>
        <Breadcrumb title={article.title || "Article Details"} />
      </Section>

      <div className="container">
        <div className="cs_blog_details_info flex flex-wrap items-center justify-between">
          <div className="cs_blog_details_info_left">
            <div className="text-sm text-gray-500">
              {new Date(article.createdAt).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "2-digit",
              })}
            </div>
          </div>
          <div className="cs_social_links_wrap flex items-center gap-3">
            <h2 className="text-base font-semibold">Share:</h2>
            <div className="cs_social_links flex gap-2">
              <Link to="https://www.facebook.com/GKCklinica/" className="hover:text-blue-600">
                <Icon icon="fa-brands:facebook-f" />
              </Link>
              <Link to="https://x.com/GkcKlinica">
                <Icon icon="fa-brands:twitter" />
              </Link>
              <Link to="https://www.instagram.com/gkcklinica/">
                <Icon icon="fa-brands:instagram" />
              </Link>
              <Link to="https://www.linkedin.com/uas/login?session_redirect=%2Fcompany%2F102332936%2F" className="hover:text-blue-700">
                <Icon icon="fa-brands:linkedin-in" />
              </Link>
            </div>
          </div>
        </div>

        <Spacing md="55" />

        {article.imageUrl?.length > 0 && (
          <div className="flex flex-wrap gap-4 mb-6">
            {article.imageUrl.map((img, i) => (
              <img
                key={i}
                src={img.startsWith("http") ? img : `${API_URL}/uploads/healthArticles/${img}`}
                alt={article.title}
                className="w-full md:w-[48%] rounded-xl shadow-sm"
              />
            ))}
          </div>
        )}

        <Spacing md="40" />

        <div className="row">
          {/* Blog Content */}
          <div className="col-lg-8">
            <div className="cs_blog_details prose max-w-none">
              <h1 className="text-4xl font-bold mb-3">{article.title}</h1>
              {article.subTitle && (
                <p className="text-gray-500 text-lg mb-6 italic">{article.subTitle}</p>
              )}
              <div
                className="leading-relaxed text-gray-700"
                dangerouslySetInnerHTML={{ __html: article.description }}
              />
            </div>
          </div>


        </div>

        <Spacing md="135" lg="100" />

        {/* Footer Banner */}
        {/* <h2 className="mb-0 cs_fs_40 cs_medium">Related Articles</h2>
        <Spacing md="57" />
        <p className="text-gray-500 mb-10">
          More articles will appear here soon.
        </p> */}
      </div>

      <Spacing md="200" xl="150" lg="110" />

      {/* <Section className="cs_footer_margin_0">
        <BannerSectionStyle9
          title="Don’t Let Your Health <br />Take a Backseat!"
          subTitle="Schedule an appointment with one of our experienced <br />medical professionals today!"
          imgUrl="/images/doctors/banner_img_3.png"
        />
      </Section> */}
    </Section>
  );
}

